import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { AppConfig } from "../../../AppConfig";
import { PageRoutes } from "../../../constants/routes";
import { LocalStorageManager } from "../../../core/storage/LocalStorageManager";
import { appActions } from "../../../ducks/app";
import { authActions } from "../../../ducks/auth";
import { couponActions } from "../../../ducks/coupon";
import { useAuth } from "../../../hooks/useAuth";
import { RedirectPickupInfo } from "../../../hooks/useCoupon";
import { useNavigation } from "../../../hooks/useNavigation";

export const useAppLinkage = () => {
  const dispatch = useDispatch();
  const { navigateToPage } = useNavigation();
  const [searchParams] = useSearchParams();
  const { isLoggedIn } = useAuth();

  const app_token = searchParams.get("app_token");

  useEffect(() => {
    if (app_token) {
      LocalStorageManager.Instance.saveObject(
        AppConfig.Instance.LocalStorageKey["appToken"],
        app_token,
      );

      const pickupInfo =
        LocalStorageManager.Instance.getObject<RedirectPickupInfo>(
          AppConfig.Instance.LocalStorageKey["pickupInfo"],
        );

      if (pickupInfo && pickupInfo.redirectUrl && pickupInfo.returnAfterLogin) {
        window.location.href = `${pickupInfo.redirectUrl}`;
      } else {
        navigateToPage(PageRoutes.APP_COUPON_LIST);
      }
    }
  }, [app_token]);

  const handleAppLinkage = (membershipId: string, password: string) => {
    dispatch(appActions.showLoading());
    dispatch(
      couponActions.linkAppMembership.started({
        user_id: membershipId,
        password,
        onComplete: () => dispatch(appActions.hideLoading()),
        onSuccess: ({ appToken }) => {
          LocalStorageManager.Instance.saveObject(
            AppConfig.Instance.LocalStorageKey["appToken"],
            appToken,
          );
          if (isLoggedIn && appToken) {
            dispatch(
              authActions.saveExternalId.started({
                app_token: appToken,
              }),
            );
          }
          /*const pickupInfo =
            LocalStorageManager.Instance.getObject<RedirectPickupInfo>(
              AppConfig.Instance.LocalStorageKey["pickupInfo"],
            );
          if (
            pickupInfo &&
            pickupInfo.returnAfterLogin &&
            pickupInfo.redirectUrl
          ) {
            window.location.href = `${pickupInfo.redirectUrl}`;
          } else {
            navigateToPage(PageRoutes.APP_COUPON_LIST);
          }*/
          navigateToPage(PageRoutes.HOME);
        },
      }),
    );
  };

  const handleReturn = () => navigateToPage(PageRoutes.APP_COUPON);

  return { handleAppLinkage, handleReturn };
};
